<template>
  <CollectionCard>
    <CollectionCardLevel :harvest-info="item.harvestInfo" />
    <CollectionCardImage
      :traits="item.traits"
      :image="item.image"
      :claimable-meth="item.claimableMeth"
    />
    <CollectionCardHeader :id="item.id" />
    <CollectionCardMethInfo
      :meth="item.harvestInfo.harvestPerDay"
      :is-harvestable="true"
    />
  </CollectionCard>
</template>
<script>
import { computed, defineComponent } from "vue";
import CollectionCardLevel from "../CollectionCard/CollectionCardLevel.vue";
import CollectionCardHeader from "../CollectionCard/CollectionCardHeader.vue";
import { TokenType } from "@/config/token-types";
import CollectionCard from "../CollectionCard/CollectionCard.vue";
import CollectionCardImage from "../CollectionCard/CollectionCardImage.vue";
import CollectionCardMethInfo from "../CollectionCard/CollectionCardMethInfo.vue";

export default defineComponent({
    components: { CollectionCardMethInfo, CollectionCardImage, CollectionCardLevel, CollectionCardHeader, CollectionCard },
    props: {
        item: Object,
    },
    setup() {
        return { TokenType }
    }
})
</script>
<style lang="scss">
</style>